import { useState, useEffect, useRef , useLayoutEffect } from "react";

export function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible };
}



export function useComponentVisibleHook(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return [ref, isComponentVisible, setIsComponentVisible]
}


// export const useIsMobile = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const checkMobileDevice = () => {
//     const isIOS = [
//       'iPad Simulator',
//       'iPhone Simulator',
//       'iPod Simulator',
//       'iPad',
//       'iPhone',
//       'iPod'
//     ].includes(navigator.platform)
//       // iPad on iOS 13 detection
//       || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

//     const isAndroidMobile = /Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent);
//     const isAndroidTablet = /Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent);

//     return {
//       isIOS,
//       isAndroidMobile,
//       isAndroidTablet
//     };
//   };
//   useLayoutEffect(() => {
//     const updateSize = () => {
//       const winSize = window.innerWidth < 1367;
//       setIsMobile(winSize || checkMobileDevice.isIOS || checkMobileDevice.isAndroidMobile || checkMobileDevice.isAndroidTablet);
//     };
//     window.addEventListener('resize', debounce(updateSize, 250));
//     return () => window.removeEventListener('resize', updateSize);
//   }, []);

//   return isMobile;
// };

// export default useIsMobile;



// const useIsMobile = () => {
//   const [isMobile, setIsMobile] = useState(false);

//   const checkMobileDevice = () => {
//     const isIOS = [
//       'iPad Simulator',
//       'iPhone Simulator',
//       'iPod Simulator',
//       'iPad',
//       'iPhone',
//       'iPod'
//     ].includes(navigator.platform)
//       // iPad on iOS 13 detection
//       || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

//     const isAndroidMobile = /Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent);
//     const isAndroidTablet = /Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent);

//     return {
//       isIOS,
//       isAndroidMobile,
//       isAndroidTablet
//     };
//   };

//   useLayoutEffect(() => {
//     const updateSize = () => {
//       const winSize = window.innerWidth < 1367;
//       setIsMobile(winSize || checkMobileDevice().isIOS || checkMobileDevice().isAndroidMobile || checkMobileDevice().isAndroidTablet);
//     };
//     // Execute updateSize once immediately after the component mounts
//     updateSize();
//     window.addEventListener('resize', debounce(updateSize, 250));
//     return () => window.removeEventListener('resize', updateSize);
//   }, []);

//   return isMobile;
// };

// export default useIsMobile;


const useMobileDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => {
      const isIOS = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      const isAndroidMobile = /Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent);
      const isAndroidTablet = /Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent);

      setIsMobile(isIOS || isAndroidMobile || isAndroidTablet);
    };

    handleResize(); // Call initially to set the correct state

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export const useTabletDetection = () => {
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const handleDeviceDetection = () => {
      if (768 <= window.innerWidth && window.innerWidth <= 1280) {
        const userAgent = navigator.userAgent.toLowerCase();
        const isTablet = /(ipad|playbook|silk|pad|tablet)/g.test(userAgent) && !/(android|iphone|ipod)/g.test(userAgent) || userAgent.includes("macintosh");
        setIsTablet(isTablet) ;
      } else {
        setIsTablet(false);
      }
    };
    handleDeviceDetection();
    window.addEventListener("resize", handleDeviceDetection);
    return () => {
      window.removeEventListener("resize", handleDeviceDetection);
    };
  }, []);
  return isTablet;
};

export const useIsTab = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleDeviceDetection = () => {
      const ua = navigator.userAgent.toLowerCase();
      const isiPad = ua.includes('ipad') ||
        (ua.includes('macintosh') && 'ontouchend' in document);
      const isAndroidTablet = ua.includes('android') && !ua.includes('mobile');
      setIsTablet(isiPad || isAndroidTablet);
    };

    handleDeviceDetection();
  }, []);

  return isTablet;
};
export const useMobileDetect = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent =
      typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    const mobileDetect = Boolean(
      userAgent.match(
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile|mobile|CriOS/i
      )
    );

    setIsMobile(mobileDetect);
  }, []);

  return isMobile;
};
export default useMobileDeviceDetection;

export function useOutsideClick(callback) {
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]);

  return ref;
}


export function useIsMobileDevice() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    const mobile = Boolean(
      userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      )
    );
    setIsMobile(mobile);
  }, []);
  return isMobile;
}
export const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isAndroid: false,
    isIOS: false,
    isSafari: false,
    isChrome: false,
  });

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase();
     // Improved checks for Android and iOS
     const isAndroid = /android/.test(userAgent);
     const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
      const isChrome = /chrome/g.test(userAgent) && !/edge/g.test(userAgent); // Exclude Edge

      setDeviceInfo({
        isAndroid,
        isIOS,
        isSafari,
        isChrome,
      });
    };

    handleDeviceDetection();
    window.addEventListener("resize", handleDeviceDetection);
    
    return () => {
      window.removeEventListener("resize", handleDeviceDetection);
    };
  }, []);

  return deviceInfo;
};

export const useFullScreenTabDetect = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const detectTablet = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      // ✅ Detect iPads (including iPad Mini, iPad Pro)
      const isIpad =
        /ipad/.test(userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

      // ✅ Detect Android Tablets (Exclude Phones)
      const isAndroidTablet =
        /android/.test(userAgent) && !/mobile/.test(userAgent);

      // ✅ Detect Other Tablets (PlayBook, Kindle Fire, Silk, etc.)
      const isOtherTablet = /(playbook|silk|tablet|kindle|pad)/g.test(userAgent);

      // ✅ Detect if the device has touch support (for better accuracy)
      const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 1;

      // 📌 Final check (detects all tablets including iPad Mini)
      setIsTablet((isIpad || isAndroidTablet || isOtherTablet) && hasTouch);
    };

    detectTablet(); // Run on mount
    window.addEventListener("resize", detectTablet); // Update on resize

    return () => {
      window.removeEventListener("resize", detectTablet);
    };
  }, []);

  return isTablet;
};

